document.addEventListener('DOMContentLoaded', function () {
  const sudoHeader = document.querySelector('.sudo-header'); // Target the sudo-header
  const mainHeader = document.querySelector('.header-wrapper'); // Or use '.header'
  const stickyClass = 'sticky-header'; // Class to toggle

  if (!sudoHeader) {
    console.error('No element found with the class .sudo-header');
    return;
  }

  if (!mainHeader) {
    console.error('No element found with the class .header-wrapper (or .header)');
    return;
  }

  const mainHeaderOffset = mainHeader.offsetHeight; // Use height as trigger

  window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    // Add or remove the sticky class based on scroll position
    if (scrollTop > mainHeaderOffset) {
      sudoHeader.classList.add(stickyClass);
      // Your existing logo-hiding code would go here (if any)
    } else {
      sudoHeader.classList.remove(stickyClass);
      // Your existing logo-showing code would go here (if any)
    }
  });
});